export type UnavailableReason = 'account' | 'relation' | 'program';

const reasons: Record<string, UnavailableReason> = {
  'USER-ARCHIVED': 'account',
  'USER-NOT-AMBASSADOR': 'account',
  'PROSPECT-ARCHIVED': 'relation',
  'RELATION-ARCHIVED': 'relation',
  'RELATION-ALREADY-ARCHIVED': 'relation',
  'RELATION-ARCHIVED-AND-REMATCH-ASKED': 'relation',
  'NO-RELATION-FOUND': 'relation',
  'NO-RELATION-MOMENT-FOUND': 'relation',
  'ORGANIZATION-ARCHIVED': 'program',
  'CAMPAIGN-ARCHIVED': 'program',
  'TEAMSPACE-ARCHIVED': 'program',
};

// Only display server-issued opaque references; legacy readable error codes stay internal.
export const readSupportReference = (value: unknown): string | null =>
  typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)
    ? value : null;

export const getUnavailableAccess = (error: unknown) => {
  const data = (error as { response?: { data?: { subtype?: string; supportReference?: string } } })?.response?.data;
  const code = data?.subtype;
  return code && reasons[code] ? { reason: reasons[code], supportReference: readSupportReference(data?.supportReference) } : null;
};
